import { and, getDocs, limit, or, orderBy, query, startAfter, where } from 'firebase/firestore';
import { map } from 'lodash';

import GenericDB from './generic-db';

export default class UserNotificationsDB extends GenericDB {
  constructor() {
    super('userNotifications');
  }

  readPaginatedNotifications(andConstraints, orConstraints, queryOrderBy, orderDirection, queryLimit, offset) {
    let queryBuilder;

    const collectionRef = this.getCollectionRef();
    const whereQueries = map(andConstraints, (constraint) => where(...constraint));

    const orWhereQueries = map(orConstraints, (constraints) => {
      if (constraints.length === 1) {
        return where(...constraints[0]);
      }

      const combinedWhereQueries = map(constraints, (combinedConstraint) => where(...combinedConstraint));
      return and(...combinedWhereQueries);
    });

    const combinedWhereConstraints = and(
      ...whereQueries,
      or(...orWhereQueries),
    );

    queryBuilder = query(collectionRef, combinedWhereConstraints);
    queryBuilder = query(queryBuilder, orderBy(queryOrderBy, orderDirection));

    if (offset !== null) {
      queryBuilder = query(queryBuilder, startAfter(offset));
    }

    queryBuilder = query(queryBuilder, limit(queryLimit));

    return getDocs(queryBuilder);
  }
}
